

















































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import { formRules } from '@/common/util/validator';
import { ExpenseType } from '@/http';
import { enums } from '@/common/enums';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class expenseType extends Vue {
    public stateType = enums.stateType;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public handleClose() {
        this.dialogVisible = false;
    }

    public searchValue: any = {
        startTime: '',
        endTime: '',
        expenseTypeName: '',
        isEnable: null,
        orderBy: '',
        ASC: true,
    };

    public timeList = [];

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('expenseType', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('expenseType'))
        ? JSON.parse(localStorage.getItem('expenseType'))
        : [
              { title: '费用类型', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];

    public datetimerange(v) {
        if (v) {
            this.searchValue.startTime = v[0];
            this.searchValue.endTime = v[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };

    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('ExpenseType_searchValue', JSON.stringify(this.searchValue));
    }
    public resetSearchValue() {
        this.searchValue = {
            startTime: '',
            endTime: '',
            expenseTypeName: '',
            isEnable: null,
            orderBy: '',
            ASC: true,
        };
        this.timeList = [];
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.ASC = true;
        } else {
            this.searchValue.ASC = false;
        }
        switch (col.prop) {
            case 'expenseTypeName':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
        }
        this.loadData();
    }

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 20;
    public isActive: boolean = false;

    public tableData: any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await ExpenseType.GetList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch {
            this.loading = false;
        }
    }

    public created() {}
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        if (sessionStorage.getItem('ExpenseType_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('ExpenseType_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            this.searchPagin = sessionStorage.getItem('ExpenseType_page') ? JSON.parse(sessionStorage.getItem('ExpenseType_page')) : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('ExpenseType_page') ? JSON.parse(sessionStorage.getItem('ExpenseType_page')) : this.searchPagin;

            this.loadData();
        }
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('ExpenseType_page', JSON.stringify(pagin));
        this.loadData();
    }

    public formData: any = {
        id: '',
        expenseTypeName: '',
        isEnable: true,
    };
    public title = '新增费用类型';
    public addNew() {
        this.title = '新增费用类型';
        this.formData = {
            expenseTypeName: '',
            isEnable: true,
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.dialogVisible = true;
    }

    public save() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增费用类型') {
                    await ExpenseType.AddOrEdit(this.formData);
                    this.$message.success('新增成功!');
                    this.dialogVisible = false;
                    this.loadData();
                } else {
                    await ExpenseType.AddOrEdit(this.formData);
                    this.$message.success('编辑成功!');
                    this.dialogVisible = false;
                    this.loadData();
                }
            }
        });
    }

    public async toEdit(id) {
        this.title = '编辑费用类型';
        let res = await ExpenseType.GetDetail(id);
        this.dialogVisible = true;
        this.formData = res;
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        ExpenseType.DoDelete(this.id1).then(() => {
            this.$message.success('删除成功');
            this.loadData();
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public id1: number;
    public toDel(id) {
        this.id1 = id;
        this.dialogConfig2 = {
            title: '删除',
            show: true,
        };
        // this.$confirm('确认删除该费用类型?', '删除费用类型', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         ExpenseType.DoDelete(id).then(() => {
        //             this.$message.success('删除成功');
        //             this.loadData();
        //         });
        //     })
        //     .catch(() => {});
    }

    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
}
